export const getSideBarShowValue = ({
  layoutReducer: { sidebarShow = [] } = {},
}) => sidebarShow;

export const configFindSelector =
  (configKey) =>
  ({ authReducer: { configs = [] } = {} }) => {
    return configs.find((config) => config.key === configKey) || {};
  };
